import { createSelector } from '@ngrx/store';
import * as fromFeature from '../../reducers.index';
import { BoelsState } from '../../reducers.index';

export const getUserData = createSelector(
  fromFeature.getStoreState,
  (state: BoelsState) => state.userDataState.userData,
);

export const isLoading = createSelector(
  fromFeature.getStoreState,
  (state: BoelsState) => state.userDataState.loading,
);
